import React from 'react';
import { Grid } from 'styled-css-grid';

import { Skeleton } from '@crm-framework/skeleton';

import { SkeletonWrapper } from './styled';

export const ShortLeadInfoSkeleton = () => (
  <SkeletonWrapper>
    <Skeleton height={25} style={{ marginBottom: 10 }} />
    <Grid gap="2px" columns={1}>
      <Skeleton height={15} amount={7} />
    </Grid>
  </SkeletonWrapper>
);
